import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

// Masked line-by-line reveal. onMount=true animates on load; otherwise when scrolled into view.
export const MaskedLines = ({ lines, italic = -1, className = "", lineClass = "", delay = 0, onMount = false, testId }) => {
  const parent = {
    hidden: {},
    show: { transition: { staggerChildren: 0.12, delayChildren: delay } },
  };
  const child = {
    hidden: { y: "108%", rotate: 2 },
    show: { y: "0%", rotate: 0, transition: { duration: 1.05, ease: EASE } },
  };
  const trigger = onMount ? { animate: "show" } : { whileInView: "show", viewport: { once: true, amount: 0.15 } };
  return (
    <motion.h1 className={className} variants={parent} initial="hidden" {...trigger} data-testid={testId}>
      {lines.map((l, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span
            variants={child}
            className={`block origin-left ${lineClass} ${i === italic ? "italic text-[#C59B27]" : ""}`}
          >
            {l}
          </motion.span>
        </span>
      ))}
    </motion.h1>
  );
};

export const Reveal = ({ children, delay = 0, y = 32, className = "", as = "div" }) => {
  const M = motion[as];
  return (
    <M
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.1 }}
      transition={{ duration: 0.9, delay, ease: EASE }}
    >
      {children}
    </M>
  );
};
